__turbopack_context__.v({
  "column": "BlockOverflowCarouselOverflowSlide-module-scss-module__UJkIOa__column",
  "fade-in": "BlockOverflowCarouselOverflowSlide-module-scss-module__UJkIOa__fade-in",
  "fade-in-scale-in": "BlockOverflowCarouselOverflowSlide-module-scss-module__UJkIOa__fade-in-scale-in",
  "fade-out": "BlockOverflowCarouselOverflowSlide-module-scss-module__UJkIOa__fade-out",
  "fade-out-scale-out": "BlockOverflowCarouselOverflowSlide-module-scss-module__UJkIOa__fade-out-scale-out",
  "image": "BlockOverflowCarouselOverflowSlide-module-scss-module__UJkIOa__image",
  "imageOverflow": "BlockOverflowCarouselOverflowSlide-module-scss-module__UJkIOa__imageOverflow",
  "imageWrapper": "BlockOverflowCarouselOverflowSlide-module-scss-module__UJkIOa__imageWrapper",
  "isActive": "BlockOverflowCarouselOverflowSlide-module-scss-module__UJkIOa__isActive",
  "isBottomLeft": "BlockOverflowCarouselOverflowSlide-module-scss-module__UJkIOa__isBottomLeft",
  "isBottomRight": "BlockOverflowCarouselOverflowSlide-module-scss-module__UJkIOa__isBottomRight",
  "isContained": "BlockOverflowCarouselOverflowSlide-module-scss-module__UJkIOa__isContained",
  "isInitialPaint": "BlockOverflowCarouselOverflowSlide-module-scss-module__UJkIOa__isInitialPaint",
  "isOverflow": "BlockOverflowCarouselOverflowSlide-module-scss-module__UJkIOa__isOverflow",
  "isPrev": "BlockOverflowCarouselOverflowSlide-module-scss-module__UJkIOa__isPrev",
  "root": "BlockOverflowCarouselOverflowSlide-module-scss-module__UJkIOa__root",
});
